module.exports = __webpack_public_path__ + "img/icon_map_13_on_101.cbf30533.png";